import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🍭 Design`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Figma Brownbags:`}</strong>{` Newly freed from jury duty, Jon K. is now leading a number of sessions on Figma.`}</li>
      <li parentName="ul"><strong parentName="li">{`Thumbprint Native:`}</strong>{` Spacers are now complete, including better usage documentation, and the team is researching future component architecture along with ways to contribute.`}</li>
    </ul>
    <h2>{`💾 API`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Atomic migration:`}</strong>{` The work to replace all deprecated Thumbprint Utility classes in `}<inlineCode parentName="li">{`website`}</inlineCode>{` with Atomic equivalents is complete. This will ease the removal of legacy code and help with performance efforts. Thank you to all those who helped with the code reviews.`}</li>
      <li parentName="ul"><strong parentName="li">{`Performance improvements:`}</strong>{` Tom G. is using a Careers page conversion to React to test a smaller CSS payload and lazy-loaded responsive image components.`}</li>
      <li parentName="ul"><strong parentName="li">{`Thumbprint Native:`}</strong>{` Daniel O. has started investigating how to publish Thumbprint Tokens to iOS and Android.`}</li>
      <li parentName="ul"><strong parentName="li">{`Open-sourcing Thumbprint:`}</strong>{` Daniel O. sent out an RFC about open-sourcing Thumbprint. He has been working with Legal and doing needed infrastructure work to make it possible.`}</li>
      <li parentName="ul"><strong parentName="li">{`Contributions:`}</strong>{` Thanks to Rich P. for adding an `}<inlineCode parentName="li">{`autoComplete`}</inlineCode>{` prop to `}<inlineCode parentName="li">{`Input`}</inlineCode>{`, Bianca G. for adding `}<inlineCode parentName="li">{`name`}</inlineCode>{` to `}<inlineCode parentName="li">{`Select`}</inlineCode>{`, and Philipp C. for adding support for non-square images to `}<inlineCode parentName="li">{`Avatar`}</inlineCode>{`.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      